import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-4 bg-slate-50">
        <Logo />
        <div className="h-1.5 w-32 overflow-hidden rounded-full bg-slate-200">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-teal-600" />
        </div>
        <p className="text-sm text-slate-400">Loading your workspace…</p>
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  return children;
}
